/**
 * Query-key factory for ambient auth/identity state — same discipline as a module's
 * `_shared/keys.ts`: hooks and cache helpers build keys from here, never array literals.
 * The hierarchy IS the invalidation API.
 */
export const authKeys = {
  all: ["auth"] as const,
  me: () => [...authKeys.all, "me"] as const,
};
